module.exports = __webpack_public_path__ + "static/img/CAPRI-MAPLE.fb70578.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/CAPRI-MAPLE.png
// module id = VX+m
// module chunks = 0